import { isProd } from "../helpers/utils"

export const reCaptchConfig = {
    loadingTimeout: 30000, // 30 seconds
    showRecaptcha: true,
    siteKey: isProd() ? '6LdCMLcpAAAAAMWZcaIwSDFqVGo3p4aNq_-e5qrb' : '6LdriHonAAAAADnpvtlDnDjWY0wdv8wv-27uxYHp'
}